export default function AuthTermsFooter() {
  return (
    <div className="text-center text-sm">
      <div className="relative">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="bg-gray-25 px-4 font-body text-gray-500">
            By continuing, you agree to our{" "}
            <a
              href="/terms-of-use"
              target="_blank"
              className="text-blue-600 underline hover:text-blue-800"
              rel="noopener"
            >
              Terms of Use
            </a>{" "}
            and{" "}
            <a
              href="/privacy-policy"
              target="_blank"
              className="text-blue-600 underline hover:text-blue-800"
              rel="noopener"
            >
              Privacy Policy
            </a>
          </span>
        </div>
      </div>
    </div>
  );
}
